import React from "react";
import { Checkbox, FormControlLabel } from "@material-ui/core";

const TreeItemLabel = ({
  nodes,
  selected,
  getOnChange,
  setIsOpenParent,
  setIsOpenNestedParent,
}) => {
  const { id, name } = nodes;

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={selected.some((item) => item === id)}
          onChange={(event) => {
            !!setIsOpenParent && setIsOpenParent([]);
            !!setIsOpenNestedParent && setIsOpenNestedParent([]);
            return getOnChange(event.currentTarget.checked, nodes);
          }}
        />
      }
      label={name ? name : id}
      key={id}
    />
  );
};

export default TreeItemLabel;
